import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/user-placeholder.jpg'
import _imports_1 from '../../../assets/icons/clock-icon.svg'
import _imports_2 from '../../../assets/images/eoh-banner.png'


const _withScopeId = n => (_pushScopeId("data-v-4a77f1eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "emergency_hours_wrapper md:!tw-pb-16 md:tw-box-border"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, "Issue name")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, "Property Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, "Location")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Date and time")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Trade Specialist")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Preferred Contractors")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Intervention Time")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, "Earmark Budget")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, "Action")
    ])
  ])
], -1))
const _hoisted_3 = { class: "property__name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "trade_specialist"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "preferred_contractor"
}
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "intervention_time" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "status_btn" }
const _hoisted_16 = { class: "mobile_-wrapper emergency__card" }
const _hoisted_17 = { class: "header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Energy Efficiency Rating", -1))
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { class: "content_list" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Property Name")
], -1))
const _hoisted_22 = { class: "description" }
const _hoisted_23 = { class: "content_list" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Location")
], -1))
const _hoisted_25 = { class: "description" }
const _hoisted_26 = { class: "content_list" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Date and time")
  ])
], -1))
const _hoisted_28 = { class: "description" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "content_list" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Trade Specialist")
  ])
], -1))
const _hoisted_32 = {
  key: 0,
  class: "description"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "content_list" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Preferred Contractors")
  ])
], -1))
const _hoisted_37 = { class: "description" }
const _hoisted_38 = {
  key: 0,
  class: "preferred_contractor"
}
const _hoisted_39 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Intervention Time")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "description intervention_time" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("p", null, "5 Min")
  ])
], -1))
const _hoisted_43 = { class: "content_list" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "more_info" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Earmark Budget")
  ])
], -1))
const _hoisted_45 = { class: "description" }
const _hoisted_46 = {
  key: 1,
  class: "empty__content md:!tw-pb-8 md:tw-box-border md:!tw-h-auto"
}
const _hoisted_47 = { class: "empty__banner md:!tw-flex md:!tw-flex-col md:!tw-gap-[1.5rem] md:!tw-items-center" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__img md:!tw-w-[70%]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_49 = { class: "empty__banner__content md:!tw-mt-0" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "You don’t have any out of hours projects yet.", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Raise your next out of hours issue at lightning speed.", -1))
const _hoisted_52 = { class: "empty__banner__content__list md:!tw-mt-4" }
const _hoisted_53 = { class: "list__item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Dispute protection"),
  /*#__PURE__*/_createTextVNode(" as standard")
], -1))
const _hoisted_55 = { class: "list__item" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Deposits secured "),
  /*#__PURE__*/_createElementVNode("strong", null, "in Escrow")
], -1))
const _hoisted_57 = { class: "list__item" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Verified trade contractors "),
  /*#__PURE__*/_createElementVNode("strong", null, " in your local area")
], -1))
const _hoisted_59 = { class: "empty__banner__footer md:!tw-mt-0 md:!tw-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_CreateEOHModal = _resolveComponent("CreateEOHModal")!
  const _component_ServiceAgreementModalForEvent = _resolveComponent("ServiceAgreementModalForEvent")!
  const _component_DeleteEventModal = _resolveComponent("DeleteEventModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.getAllEvent.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            class: "button button-orange",
            "prepend-icon": "mdi-plus-circle",
            onClick: $setup.onClickAddNew
          }, {
            default: _withCtx(() => [
              _createTextVNode("ADD NEW")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_table, { class: "emergency_hours_table" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAllEvent, (event) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: event.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, _toDisplayString(event.title), 1)
                    ]),
                    _createElementVNode("td", _hoisted_3, [
                      _createElementVNode("p", null, _toDisplayString(event.EOHProperties[0]?.property?.address), 1),
                      (event.EOHProperties.length - 1 > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "+" + _toDisplayString(event.EOHProperties.length - 1), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, _toDisplayString(event.EOHProperties[0]?.property?.postcode), 1)
                    ]),
                    _createElementVNode("td", null, [
                      ($setup.getWeekName(event?.days))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.getWeekName(event?.days)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(event?.fromTime) + " to " + _toDisplayString(event?.toTime), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (event.EOHSpecialism?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("p", null, _toDisplayString(event.EOHSpecialism[0]?.subCategories?.label), 1),
                            (event?.EOHSpecialism.length - 1 > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(event?.EOHSpecialism.length - 1) + "+", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                    ]),
                    _createElementVNode("td", null, [
                      (event.EOHPreferredContractor.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (event.EOHPreferredContractor.length - 1 >= 0)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", null, _toDisplayString(event.EOHPreferredContractor[0]?.user?.firstName) + " " + _toDisplayString(event.EOHPreferredContractor[0]?.user?.lastName), 1),
                            (event.EOHPreferredContractor.length - 1 > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(event.EOHPreferredContractor.length - 1) + "+", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("p", null, _toDisplayString(event?.SLATime) + " Min", 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, "£ " + _toDisplayString(event?.earnmarkBudget), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_v_btn, {
                          class: "edit_button",
                          icon: "mdi-pencil",
                          onClick: ($event: any) => ($setup.onClickEditButton(event.id))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          class: "delete_button",
                          icon: "mdi-delete",
                          onClick: ($event: any) => ($setup.onClickDeleteButton(event.id))
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAllEvent, (event) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                class: "emergency_hours_card",
                key: event.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_v_btn, {
                      class: "edit_button",
                      icon: "mdi-pencil",
                      onClick: ($event: any) => ($setup.onClickEditButton(event.id))
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", null, _toDisplayString(event.EOHProperties[0]?.property?.address), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", null, _toDisplayString(event.EOHProperties[0]?.property?.postcode), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        ($setup.getWeekName(event?.days))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($setup.getWeekName(event?.days)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(event?.fromTime) + " to " + _toDisplayString(event?.toTime), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      (event.EOHSpecialism?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("p", null, _toDisplayString(event.EOHSpecialism[0]?.subCategories?.label), 1),
                            (event.EOHSpecialism.length - 1 > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(event.EOHSpecialism.length - 1) + "+", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_34, "-"))
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        (event.EOHPreferredContractor.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              (event.EOHPreferredContractor.length - 1 >= 0)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, _toDisplayString(event.EOHPreferredContractor[0]?.user?.firstName) + " " + _toDisplayString(event.EOHPreferredContractor[0]?.user?.lastName), 1),
                              (event.EOHPreferredContractor.length - 1 > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(event.EOHPreferredContractor.length - 1) + "+", 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_41, "-"))
                      ])
                    ]),
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("p", null, "£ " + _toDisplayString(event?.earnmarkBudget), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _hoisted_51,
              _createElementVNode("ul", _hoisted_52, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_54
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_56
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_58
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_v_btn, {
                class: "button button-purple",
                width: "100%",
                onClick: $setup.onClickAddNew
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Raise a new Project")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])),
    ($setup.isShowCreateEOH)
      ? (_openBlock(), _createBlock(_component_CreateEOHModal, {
          key: 2,
          isShowHeader: false,
          selectedEventId: $setup.selectedEventId,
          onOnClickCancel: $setup.onClickCancel,
          onOnClickPostButton: $setup.onClickPostButton
        }, null, 8, ["selectedEventId", "onOnClickCancel", "onOnClickPostButton"]))
      : _createCommentVNode("", true),
    ($setup.isShowServiceAgreement)
      ? (_openBlock(), _createBlock(_component_ServiceAgreementModalForEvent, {
          key: 3,
          createdEvent: $setup.createdEvent,
          selectedEventId: $setup.selectedEventId,
          onOnClose: $setup.onCloseServiceAgreementModal
        }, null, 8, ["createdEvent", "selectedEventId", "onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowDeleteModal)
      ? (_openBlock(), _createBlock(_component_DeleteEventModal, {
          key: 4,
          selectedEventId: $setup.selectedEventId,
          onCancelDeleteModal: $setup.cancelDeleteModal
        }, null, 8, ["selectedEventId", "onCancelDeleteModal"]))
      : _createCommentVNode("", true)
  ], 64))
}